import { ref, type Ref } from 'vue';
import { Announcement } from '@/modules/announcement/models/Announcement';

export const unseenAnnouncements: Ref<Announcement[] | undefined> = ref(undefined);
